import React from 'react';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import makeStyles from '@material-ui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  summary: {
    textAlign: 'center'
  },
  hideIcon: {
    visibility: 'hidden'
  },
  buttons: {
    marginRight: theme.spacing(1)
  }
}));

const PreferenceListHdr = () => {
  const classes = useStyles();
  const summaryList = [{txt: 'Type', width: 10}, {txt: 'Instance', width: 15}, {txt: 'Id', width: 15}, 
    {txt: 'Last Update', width: 30}, {txt: 'Manage', width: 30}];
  return (
    <ExpansionPanel expanded={false}>
      <ExpansionPanelSummary expandIcon={ExpandMoreIcon} className={classes.summary} classes={{ expandIcon: classes.hideIcon }}>
        {
          summaryList.map(({ txt, width}, idx) => {
            return (
              <Typography key={idx} style={{ flexBasis: `${width}%` }}>{txt}</Typography>
            );
          })
        }
      </ExpansionPanelSummary>
    </ExpansionPanel>
  );
};

export default React.memo(PreferenceListHdr);